import { User } from './user';

export class CustomerUser extends User {

  partnerId: number;        // customer trading partner id
  partner;                  // customer trading partner
}
